import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import styled from "styled-components/macro";

import {
  MoreButton,
  MoreButtonText,
} from "Signups/SignupView/SignupSheet/Screens/Options/Options/MoreButton";
import { AnimatePresence, motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon/FnrIcon";
import { FnrPopover } from "UI/FnrPopover2";
import { colors } from "UI/colors";

import AddMember from "./AddMember";

export default function AddRespondent({
  signupItemID,
  isFull = false,
  signupExpired = false,
  signupArchived = false,
  signupListID,
}) {
  const [showPopover, setShowPopover] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    let successMsgTimeout;

    if (successMessage) {
      successMsgTimeout = setTimeout(() => {
        setSuccessMessage(null);
      }, 3000);
    }

    return () => clearTimeout(successMsgTimeout);
  }, [successMessage]);

  const buttonRef = useRef();

  const togglePopover = () => {
    setShowPopover((currentVal) => !currentVal);
  };

  const closePopover = () => {
    setShowPopover(false);
  };

  return (
    <Wrapper>
      <MoreButton
        forceHover={showPopover}
        onClick={togglePopover}
        ref={buttonRef}
      >
        <FnrIcon fas fa-plus-circle />
        <MoreButtonText>Add a member</MoreButtonText>
      </MoreButton>
      <AnimatePresence>
        {successMessage && (
          <SuccessMessage
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0 }}
          >
            <FnrIcon fas fa-check />
            <SuccessText>{successMessage}</SuccessText>
          </SuccessMessage>
        )}
      </AnimatePresence>
      <FnrPopover
        show={showPopover}
        buttonRef={buttonRef}
        onShouldClose={closePopover}
      >
        <PopoverInside>
          {isFull ? (
            <NotAvailable>
              <NotAvailableTitle>This item is full.</NotAvailableTitle>
              To add a member, please increase the number of available slots or
              remove someone else.
            </NotAvailable>
          ) : signupArchived || signupExpired ? (
            <NotAvailable>
              <NotAvailableTitle>This signup is closed.</NotAvailableTitle>
              {"To add a member, please "}
              {signupArchived
                ? "unarchive this signup"
                : "adjust the signup's closing date"}
              {" in "}
              <Link to={"/signups/" + signupListID + "/options"}>
                Signup Options
              </Link>
              .
            </NotAvailable>
          ) : (
            <AddMember
              signupItemID={signupItemID}
              setSuccessMessage={setSuccessMessage}
              closePopover={() => setShowPopover(false)}
            />
          )}
        </PopoverInside>
      </FnrPopover>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const SuccessMessage = styled(motion.div)`
  position: absolute;
  left: 100%;
  margin-left: 10px;
  white-space: nowrap;
  background: ${colors.fnGreen};
  padding: 4px 8px;
  border-radius: 6px;
  color: white;
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
  margin-top: 2px;
  z-index: 1000;
`;
const SuccessText = styled.div`
  margin-left: 6px;
`;

const PopoverInside = styled.div`
  max-width: 240px;
`;

const NotAvailable = styled.div`
  font-size: 14px;
  padding: 5px 10px;
  color: white;
  font-weight: 400;
  line-height: 17px;
`;
const NotAvailableTitle = styled.div`
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 4px;
`;
